/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateImagingMachineDto } from './CreateImagingMachineDto';
import {
    instanceOfCreateImagingMachineDto,
    CreateImagingMachineDtoFromJSON,
    CreateImagingMachineDtoFromJSONTyped,
    CreateImagingMachineDtoToJSON,
} from './CreateImagingMachineDto';
import type { CreateLinearAcceleratorDto } from './CreateLinearAcceleratorDto';
import {
    instanceOfCreateLinearAcceleratorDto,
    CreateLinearAcceleratorDtoFromJSON,
    CreateLinearAcceleratorDtoFromJSONTyped,
    CreateLinearAcceleratorDtoToJSON,
} from './CreateLinearAcceleratorDto';
import type { CreateOtherMedicalSystemDto } from './CreateOtherMedicalSystemDto';
import {
    instanceOfCreateOtherMedicalSystemDto,
    CreateOtherMedicalSystemDtoFromJSON,
    CreateOtherMedicalSystemDtoFromJSONTyped,
    CreateOtherMedicalSystemDtoToJSON,
} from './CreateOtherMedicalSystemDto';
import type { CreateOtherMvTherapyMachineDto } from './CreateOtherMvTherapyMachineDto';
import {
    instanceOfCreateOtherMvTherapyMachineDto,
    CreateOtherMvTherapyMachineDtoFromJSON,
    CreateOtherMvTherapyMachineDtoFromJSONTyped,
    CreateOtherMvTherapyMachineDtoToJSON,
} from './CreateOtherMvTherapyMachineDto';
import type { CreateOtherTreatmentMachineDto } from './CreateOtherTreatmentMachineDto';
import {
    instanceOfCreateOtherTreatmentMachineDto,
    CreateOtherTreatmentMachineDtoFromJSON,
    CreateOtherTreatmentMachineDtoFromJSONTyped,
    CreateOtherTreatmentMachineDtoToJSON,
} from './CreateOtherTreatmentMachineDto';
import type { CreateSoftwareDto } from './CreateSoftwareDto';
import {
    instanceOfCreateSoftwareDto,
    CreateSoftwareDtoFromJSON,
    CreateSoftwareDtoFromJSONTyped,
    CreateSoftwareDtoToJSON,
} from './CreateSoftwareDto';

/**
 * @type CreateMedicalSystemRtSystemDto
 * 
 * @export
 */
export type CreateMedicalSystemRtSystemDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateImagingMachineDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateLinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateLinearAcceleratorDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateOtherMedicalSystemDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateOtherMvTherapyMachineDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateOtherTreatmentMachineDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateSoftwareDto;


export function CreateMedicalSystemRtSystemDtoFromJSON(json: any): CreateMedicalSystemRtSystemDto {
    return CreateMedicalSystemRtSystemDtoFromJSONTyped(json, false);
}

export function CreateMedicalSystemRtSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMedicalSystemRtSystemDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateImagingMachineDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateLinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateLinearAcceleratorDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateLinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateOtherMedicalSystemDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateOtherMvTherapyMachineDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateOtherTreatmentMachineDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateSoftwareDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of CreateMedicalSystemRtSystemDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateMedicalSystemRtSystemDtoToJSON(value?: CreateMedicalSystemRtSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateImagingMachineDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateLinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateLinearAcceleratorDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateOtherMedicalSystemDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateOtherMvTherapyMachineDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateOtherTreatmentMachineDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateSoftwareDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateMedicalSystemRtSystemDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateMedicalSystemRtSystemDto interface.
 */
export function instanceOfCreateMedicalSystemRtSystemDto(value: any): value is CreateMedicalSystemRtSystemDto {
    if (instanceOfCreateImagingMachineDto(value)) return true;
    if (instanceOfCreateLinearAcceleratorDto(value)) return true;
    if (instanceOfCreateOtherMedicalSystemDto(value)) return true;
    if (instanceOfCreateOtherMvTherapyMachineDto(value)) return true;
    if (instanceOfCreateOtherTreatmentMachineDto(value)) return true;
    if (instanceOfCreateSoftwareDto(value)) return true;
    return false;
}

